<template>
  <section class="section">
    <div class="container">
      <div class="row">
        <router-link to="/restaurante/liquidaciones" class="pull-right">Volver a la lista</router-link>
      </div>
      <div class="row">
        <div class="box-style line-top" ref="detalle">
          <div class="form smart-form">
            <div class="box-header text-center">            
              <h2 class="pull-left">Liquidacion N° {{liquidacion.numero}}</h2>
              <h2 class="text-center">{{liquidacion.proveedor.razonSocial}}</h2>
              <div class="box-date">
                <b>{{liquidacion.estado}}</b>
              </div>
            </div>
            <div class="box-body">
              <div class="row">
                <div class="col-xs-12 col-sm-4">
                  <p class="size-14">
                    <b>Emitida el:</b>
                    {{liquidacion.fechaCreacion | formatFecha}}
                    <br>
                    <b>Cantidad de Pedidos:</b>
                    {{liquidacion.entregas.length}}
                    <br>
                    <b>Monto total de los pedidos:</b>
                    {{liquidacion.montoSinImpuestos | formatMoneda}}
                  </p>
                </div>
                <div class="col-xs-12 col-sm-4">
                    <b>Comisión:</b>
                    {{liquidacion.comision}} %
                    <br>
                    <b>Monto comisión:</b>
                    {{liquidacion.montoBrutoComision | formatMoneda}}
                    <br>
                    <b>Monto a cobrar:</b>
                    {{liquidacion.montoAPagarAlProveedor | formatMoneda}}
                </div>
                <div class="col-xs-12 col-sm-4">
                <div class="form-group">
                  <label>Exportar Liquidación</label>
                  <br/>
                  <button class="btn btn-sm btn-outline-grey-green" @click="exportXls(false)">
                    EXCEL
                  </button>
                  <button class="btn btn-sm btn-outline-grey-green" @click="exportPdf(false)">
                    PDF
                  </button>
                </div>                
                </div>
              </div>
              <div class="row box-header">
                <div class="col-xs-12 col-sm-12">
                <div class="form-group col-xs-12 col-sm-3" style="padding-left:0;">
                  <label>EMPRESA</label>
                  <br/>                  
                  <select class="form-control select2 filter-select2" ref="slEmpresa" multiple style="width:100%" data-select2-container="big-text">
                    <option v-for="empresa in empresas" :key="empresa._id" :value="empresa._id">{{empresa.razonSocial}}</option>
                  </select>
                  <a @click="quitarFiltrosEmpresa" class="disable-filter hide" :class="{show: filtros.empresas.length > 0}">Quitar filtro empresas</a>
                </div>
                <div class="form-group col-xs-12 col-sm-2" style="padding-left:0;">
                  <label>COMBO</label>
                  <br/>                  
                  <select class="form-control select2 filter-select2" ref="slCombo" multiple style="width:100%" data-select2-container="big-text">
                    <option v-for="combo in combos" :key="combo._id" :value="combo._id">{{combo.nombre}}</option>
                  </select>
                  <a @click="quitarFiltrosCombo" class="disable-filter hide" :class="{show: filtros.combos.length > 0}">Quitar filtro combos</a>
                </div>
                <div class="form-group col-xs-12 col-sm-3" style="padding-left:0;">
                  <label>DESDE</label>
                  <date-picker v-model="filtros.desde" :max-date="new Date()"></date-picker>
                  <!-- agregar class "show" para mostrar el link quitar filtro-->
                  <a href="#" class="disable-filter hide">Quitar filtro fecha</a>
                </div>
                <div class="form-group col-xs-12 col-sm-3" style="padding-left:0;">
                  <label>HASTA</label>
                  <date-picker v-model="filtros.hasta" :max-date="new Date()"></date-picker>
                  <!-- agregar class "show" para mostrar el link quitar filtro-->
                  <a href="#" class="disable-filter hide">Quitar filtro fecha</a>
                </div>
                <div class="col-xs-12 col-sm-1" style="padding-left:0;">
                <div class="form-group">
                  <label>EXPORTAR SELECCIONADOS</label>
                  <br/>
                      <div class="btn-group">
                        <button class="btn btn-outline-grey-green dropdown-toggle" data-toggle="dropdown" aria-expanded="true">
                          Exportar  <i class="fa fa-angle-down"></i>
                        </button>
                        <ul class="dropdown-menu">
                          <li>
                            <a @click.prevent="exportXls(true)">EXCEL</a>
                          </li>
                          <li>
                            <a @click.prevent="exportPdf(true)">PDF</a>
                          </li>
                        </ul>
                      </div>
                </div>                

                </div>
              </div>
              </div>
              <div class="row">
              <br/>              
                <div class="col-xs-12 col-sm-3">
                  <p class="size-14">
                    <b>Cantidad de Pedidos:</b>
                    {{entregasFiltradas.length}}
                  </p>
                </div>
                <div class="col-xs-12 col-sm-3">
                  <p class="size-14">
                    <b>Monto total de los pedidos:</b>
                    {{montoTotalSinImpuestos | formatMoneda}}
                  </p>
                </div>
                <div class="col-xs-12 col-sm-3">
                    <b>Monto comisión:</b>
                    {{montoComision | formatMoneda}}
                </div>
                <div class="col-xs-12 col-sm-3">
                    <b>Monto a cobrar:</b>
                    {{montoACobrar | formatMoneda}}
                </div>
              </div>

              <div class="row">
                  <div>
                    <ul class="nav nav-tabs" role="tablist">
                      <li role="presentation" class="active"><a href="#lista" aria-controls="lista" role="tab" data-toggle="tab">Lista de pedidos</a></li>
                      <li role="presentation"><a href="#movimientos" aria-controls="movimientos" role="tab" data-toggle="tab">Movimientos</a></li>
                    </ul>
                    <div class="tab-content">
                        <div role="tabpanel" class="tab-pane active" id="lista">
                        <table class="table">
                          <thead>
                            <tr>
                              <th>Número</th>
                              <th>Pedido por</th>
                              <th>Legajo</th>                              
                              <th>Fecha entrega</th>
                              <th class="text-right">Monto pedido</th>
                              <th class="text-right">Acciones</th>
                            </tr>
                          </thead>
                          <tbody v-if="entregasFiltradas.length > 0">
                            <template v-for="entrega in entregasPaginadas">
                              <tr>
                                <td>{{entrega.numero}}</td>
                                <td>{{entrega.usuario.displayName}}</td>
                                <td>{{entrega.usuario.legajo}}</td>
                                <td>{{entrega.fechaEntrega | formatFecha}}</td>
                                <td class="text-right">{{entrega.montoBruto | formatMoneda}}</td>
                                <td class="text-center">
                                  <button class="btn btn-link btn-xs" @click="entrega.verDetalle = !entrega.verDetalle">Ver detalle</button>
                                </td>
                              </tr>
                              <tr v-if="entrega.verDetalle">
                                <td colspan="5">
                                  <table class="table table-bordered">
                                    <tbody>
                                      <tr v-for="plato in entrega.platos">
                                        <td class="text-right">{{plato.cantidad}}x</td>
                                        <td colspan="3">{{plato.plato.nombre}}</td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                            </template>
                          </tbody>
                        </table>
                        <div class="smart-form" v-if="paginador.totalItems > 0">
                          <div class="text-center center-block">
                            <nav aria-label="Page navigation">
                              <ul class="pagination pagination-sm">
                              <li>
                                <a @click="goToPrevPage()"  aria-label="Anterior">
                                <span aria-hidden="true">«</span>
                                </a>
                              </li>
                              <li><span>Página {{paginador.currentPage}} de {{paginador.totalPages}}</span></li>
                              <li>
                                <a @click="goToNextPage()" aria-label="Siguiente">
                                <span aria-hidden="true">»</span>
                                </a>
                              </li>
                              </ul>
                            </nav>
                          </div>
                        </div>                        
                        </div>
                        <div role="tabpanel" class="tab-pane" id="movimientos">
                          <table class="table">
                            <thead>
                              <tr>
                                <th>Fecha</th>
                                <th>Tipo</th>
                                <th>Comprobante</th>
                                <th>Monto</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="movimiento in movimientosFiltrados" :key="movimiento._id">
                                <td>{{movimiento.fecha | formatFecha}}</td>
                                <td>{{movimiento.tipo}}</td>
                                <td>{{movimiento.comprobante}}</td>
                                <td>{{movimiento.importe | formatMoneda}}</td>
                              </tr>
                            </tbody>
                          </table>                        
                        </div>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="hidden" ref="contenedorExport"></div>
  </section>
</template>
<script>
  import '../../assets/css/select2_status.css'
  import '../../assets/css/select2.css'
  import moment from 'moment'
  import PHE from 'print-html-element'
  import $ from 'jquery'
  import 'select2'
  import DatePicker from '../Shared/DatePicker'
  import {uniqBy} from 'lodash'
  import JsPDF from 'jspdf'
  import 'jspdf-autotable'
  import TableExport from 'tableexport'

  export default {
    components: {
      'date-picker': DatePicker
    },
    data () {
      return {
        paginador: {
          pageSize: 10,
          currentPage: 1,
          totalItems: 0,
          totalPages: 0
        },
        liquidacion: null,
        movimientos: [],
        empresas: [],
        filtros: {
          desde: null,
          hasta: null,
          combos: [],
          empresas: []
        }
      }
    },
    filters: {
      formatFecha (value) {
        return moment(new Date(value)).format('DD/MM/YYYY HH:mm')
      },
      formatMoneda (value) {
        return '$' + parseFloat(value).toFixed(2)
      }
    },
    methods: {
      imprimir () {
        PHE.printElement(this.$refs.detalle)
      },
      quitarFiltrosEmpresa () {
        const me = this
        me.filtros.empresas = []
        $(me.$refs.slEmpresa).val(me.filtros.empresas).trigger('change')
      },
      quitarFiltrosCombo () {
        const me = this
        me.filtros.combos = []
        $(me.$refs.slCombo).val(me.filtros.combos).trigger('change')
      },
      exportXls (filtered) {
        const me = this
        let datos = { entregas: me.liquidacion.entregas, bruto: me.liquidacion.montoSinImpuestos, comision: me.liquidacion.montoBrutoComision, total: me.liquidacion.montoSinImpuestos - me.liquidacion.montoBrutoComision }
        if (filtered) {
          datos = { entregas: me.entregasFiltradas, bruto: me.montoTotalSinImpuestos, comision: me.montoComision, total: me.montoTotalSinImpuestos - me.montoComision }
        }

        let title = me.liquidacion.proveedor.razonSocial + ' | Detalle de la liquidacion: '
        title += me.liquidacion.numero
        title += ' | Estado: '
        title += me.liquidacion.estado
        let subtitle = 'Cantidad de pedidos: ' + datos.entregas.length
        subtitle += ' | Monto total de los pedidos: ' + '$' + parseFloat(datos.bruto).toFixed(2)
        subtitle += ' | Monto comision: ' + '$' + parseFloat(datos.comision).toFixed(2)
        subtitle += ' | Monto a cobrar: ' + '$' + parseFloat(datos.total).toFixed(2)
        let html = `<table class="table" id="tblExport">
        <thead>
          <tr>
            <th colspan='5'>${title}</th>
          </tr>
          <tr>
            <th colspan='5'>${subtitle}</th>
          </tr>
          <tr>
            <th>Número</th>
            <th>Pedido por</th>
            <th>Legajo</th>
            <th>Fecha entrega</th>
            <th>Monto pedido</th>
          </tr>
        </thead>
        <tbody>
          ${datos.entregas.map(entrega => {
            return `<tr>
              <td>${entrega.numero}</td>
              <td>${entrega.usuario.displayName}</td>
              <td>${entrega.usuario.legajo}</td>
              <td>${moment(entrega.fechaEntrega).format('DD/MM/YYYY HH:mm')}</td>
              <td>${'$' + parseFloat(entrega.montoBruto).toFixed(2)}</td>
            </tr>`
          })
          }
        </tbody>
      </table>`
        $(me.$refs.contenedorExport).html(html)
        let table = document.getElementById('tblExport')
        let tableExp = new TableExport(table, {
          exportButtons: false,
          formats: ['xls', 'csv', 'txt', 'xlsx']
        })
        tableExp.types.date.assert = function (v) {
          return false
        }
        let exportData = tableExp.getExportData()
        tableExp.export2file(exportData.tblExport.xlsx.data, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'detalleLiquidacion-' + me.liquidacion.numero, '.xlsx')
      },
      goToNextPage () {
        const me = this
        if (me.paginador.currentPage < me.paginador.totalPages) {
          me.paginador.currentPage += 1
        }
      },
      goToPrevPage () {
        const me = this
        if (me.paginador.currentPage > 1) {
          me.paginador.currentPage -= 1
        }
      },
      exportPdf (filtered) {
        const me = this
        let datos = { entregas: me.liquidacion.entregas, bruto: me.liquidacion.montoSinImpuestos, comision: me.liquidacion.montoBrutoComision, total: me.liquidacion.montoSinImpuestos - me.liquidacion.montoBrutoComision }
        if (filtered) {
          datos = { entregas: me.entregasFiltradas, bruto: me.montoTotalSinImpuestos, comision: me.montoComision, total: me.montoTotalSinImpuestos - me.montoComision }
        }
        var img = new Image()
        img.src = '/images/bird.png'
        img.onload = function () {
          let title = me.liquidacion.proveedor.razonSocial + ' | Detalle de la liquidacion: '
          title += me.liquidacion.numero
          title += ' | Estado: '
          title += me.liquidacion.estado
          let subtitle = 'Cantidad de pedidos: ' + datos.entregas.length
          subtitle += ' | Monto total de los pedidos: ' + '$' + parseFloat(datos.bruto).toFixed(2)
          subtitle += ' | Monto comision: ' + '$' + parseFloat(datos.comision).toFixed(2)
          subtitle += ' | Monto a cobrar: ' + '$' + parseFloat(datos.total).toFixed(2)
          const columns = ['Número', 'Pedido por', 'Legajo', 'Fecha entrega', 'Monto pedido']
          const rows = datos.entregas.map((entrega) => {
            return [
              entrega.numero,
              entrega.usuario.displayName,
              entrega.usuario.legajo,
              moment(entrega.fechaEntrega).format('DD/MM/YYYY HH:mm'),
              '$' + parseFloat(entrega.montoBruto).toFixed(2)
            ]
          })
          const doc = new JsPDF('l')
          doc.autoTable(columns, rows, {
            margin: 25,
            bodyStyles: {
              overflow: 'visible',
              fontSize: 8,
              columnWidth: 'wrap'
            },
            headerStyles: {
              fillColor: [147, 165, 18]
            },
            addPageContent: function (data) {
              doc.addImage(img, 'PNG', 25, 10, 12, 12)
              doc.setFontSize(12)
              doc.text(title, 40, 14)
              doc.setFontSize(10)
              doc.text(subtitle, 40, 19)
            }
          })
          doc.save('detalleLiquidacion-' + me.liquidacion.numero + '.pdf')
        }
      }
    },
    computed: {
      totalItems () {
        return this.liquidacion.entregas.length
      },
      totalPages () {
        return Math.ceil(this.totalItems / this.paginador.pageSize)
      },
      movimientosFiltrados () {
        return this.movimientos.filter((movimiento) => {
          return movimiento.esPago
        })
      },
      montoACobrar () {
        const me = this
        return me.montoTotalSinImpuestos - me.montoComision
      },
      montoComision () {
        const me = this
        return me.montoTotalSinImpuestos * (me.liquidacion.comision / 100)
      },
      montoTotalSinImpuestos () {
        const me = this
        let monto = 0
        me.entregasFiltradas.map((entrega) => {
          monto += entrega.montoTotal
        })
        return monto
      },

      entregasFiltradas () {
        const me = this
        let entregas = me.liquidacion.entregas
        if (me.filtros.desde) {
          entregas = entregas.filter((entrega) => {
            return new Date(entrega.fechaEntrega) >= moment(me.filtros.desde).startOf('day').toDate()
          })
        }
        if (me.filtros.hasta) {
          entregas = entregas.filter((entrega) => {
            return new Date(entrega.fechaEntrega) < moment(me.filtros.hasta).endOf('day').toDate()
          })
        }
        if (me.filtros.combos.length > 0) {
          entregas = entregas.filter((entrega) => {
            return me.filtros.combos.includes(entrega.combo._id)
          })
        }
        if (me.filtros.empresas.length > 0) {
          entregas = entregas.filter((entrega) => {
            return me.filtros.empresas.includes(entrega.sucursal.empresa)
          })
        }
        me.paginador.totalItems = entregas.length
        me.paginador.totalPages = Math.ceil(me.paginador.totalItems / me.paginador.pageSize)

        return entregas
      },
      entregasPaginadas () {
        const me = this
        let desde = (me.paginador.currentPage - 1) * me.paginador.pageSize
        let hasta = me.paginador.currentPage * me.paginador.pageSize
        let filtrados = me.entregasFiltradas.filter((entrega, idx) => {
          return idx >= desde && idx < hasta
        })
        return filtrados
      },
      combos () {
        const me = this
        const combos = me.liquidacion.entregas.map((entrega) => {
          return entrega.combo
        })
        let combosDistinct = uniqBy(combos, (combo) => {
          return combo._id
        })
        return combosDistinct
      }
    },
    mounted () {
      const me = this
      const id = me.$route.params.id
      me.$http.get(`/api/restaurante/liquidaciones/${id}`, {
        params: {
          id: id
        }
      }).then(({body}) => {
        let liquidacion = body.liquidacion
        console.log(liquidacion)
        liquidacion.entregas.forEach((entrega) => {
          entrega.verDetalle = false
        })
        me.liquidacion = liquidacion
        me.movimientos = body.movimientos
        const emps = body.empresas.map((suc) => {
          return suc.empresa
        })
        me.empresas = uniqBy(emps, (emp) => {
          return emp._id
        })
      }, (err) => {
        console.error(err)
      }).then(() => {
        $.datepicker.setDefaults($.datepicker.regional['es'])
        $('.datepicker.desde').datepicker({
          dateFormat: 'dd/mm/yy',
          beforeShowDay: $.datepicker.noWeekends
        }).datepicker('setDate', moment().add(-30, 'days').toDate())
        $('.datepicker.hasta').datepicker({
          dateFormat: 'dd/mm/yy',
          beforeShowDay: $.datepicker.noWeekends
        }).datepicker('setDate', moment().add(-1, 'days').toDate())
        $(me.$refs.slEmpresa).select2({
          placeholder: 'Seleccione Empresas'
        }).on('change', (e) => {
          me.filtros.empresas = $(me.$refs.slEmpresa).val()
        })
        $(me.$refs.slCombo).select2({
          placeholder: 'Seleccione un Combo'
        }).on('change', (e) => {
          me.filtros.combos = $(me.$refs.slCombo).val()
        })
      })
    }
  }
</script>



// WEBPACK FOOTER //
// DetalleLiquidacion.vue?2889bbf0